import apiCall from '@/repository'

const user = JSON.parse(localStorage.getItem('user'))

const state = user ? { status: { loggedIn: true }, user } : { status: {}, user: null };

const actions = {
  loginUser({ dispatch, commit }, response){
    if(response.headers["x-token-refresh"]){
      localStorage.setItem('token', response.headers["x-token-id"])
      localStorage.setItem('refresh-token', response.headers["x-token-refresh"])
      apiCall.get('/v1/me')
      .then(response => {
        const user = response.data
        localStorage.setItem('user', JSON.stringify(user))
        commit('loginSuccess', user);
        location.href = '/'
      })
    }
  },

  logoutUser({ commit }){
    commit('logout')
  },

  editProfile({ dispatch, commit }, user){
    localStorage.setItem('user', JSON.stringify(user))
    commit('changeAdminData', user)
  }
}

const mutations = {
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;
        state.error = null;
    },

    changeAdminData(state, user){
      state.user = user
    },

    loginFailure(state) {
        state.status = { loggedIn: 'fail' };
        state.user = null;
        state.error = 'Invalid credentials';
    },

    logout(state){
      localStorage.removeItem('token');
      localStorage.removeItem('refresh-token');
      localStorage.removeItem('user');
      localStorage.removeItem('dTok');
      state.status = {};
      state.user = null;
      state.error = null;
    }
}

export const currentUser = {
  namespaced: true,
  state,
  actions,
  mutations
};
